import styled from 'styled-components';

import { variants } from './types';

type VariantType = (typeof variants)[number];

const backgroundColors: { [key in VariantType]: string } = {
  yellow: 'rgba(240, 206, 29, 0.25)',
  green: 'rgba(var(--c-rgb-green-600), 0.25)',
  blue: 'rgba(var(--c-rgb-brand-600), 0.25)',
  grey: 'var(--c-nd-100)',
  red: 'rgba(var(--c-rgb-red-400), 0.25)',
};

const borderColor: { [key in VariantType]: string } = {
  yellow: 'var(--c-yellow-400)',
  green: 'var(--c-green-600)',
  blue: 'var(--c-brand-600)',
  grey: 'var(--c-nd-600)',
  red: 'var(--c-red-400)',
};

const fontColor: { [key in VariantType]: string } = {
  yellow: 'var(--c-yellow-400)',
  green: 'var(--c-green-800)',
  blue: 'var(--c-brand-800)',
  grey: 'var(--c-nd-600)',
  red: 'var(--c-red-300)',
};

const Root = styled.div<{ variant: VariantType }>`
  --border-size: 4px;
  color: ${({ variant }) => fontColor[variant]};
  background-color: ${({ variant }) => backgroundColors[variant]};
  border-left: var(--border-size) solid ${({ variant }) => borderColor[variant]};
  border-radius: var(--border-size);
  padding: var(--unit);
`;

type Props = {
  children?: React.ReactNode;
  variant?: VariantType;
};

export const Blockquote = ({ children, variant = 'grey' }: Props) => {
  return <Root variant={variant}>{children}</Root>;
};
